import React from "react";
import styled from "@emotion/styled";

const Footer: React.FC= () => {
  return (
    <Container>
      <FirstBox>
        <ContentsContainter>
          <HTextBox>
            <BoldText
              href='https://photypeta.oopy.io/terms'
            >서비스 이용약관</BoldText>
            <LinkUrl 
              href='https://photypeta.oopy.io/5ed1126f-4758-47fe-82ad-bf86c3467082'
              >개인정보 처리방침</LinkUrl>
          </HTextBox>
        </ContentsContainter>
      </FirstBox>
      <SecondBox>
        <ContetBoxInSecondBox>
          <ImgBox>
            <Image src='/images/logoImg2.png'></Image>
          </ImgBox>
          <TextBoxInSecond>
            <Firstline>
              <Text3>(주) &nbsp;</Text3>
              <BoldText2>포티페타&nbsp;&nbsp;&nbsp;</BoldText2>
              <Text3>대표자: 김중연</Text3>
            </Firstline>
            <SecondLine>
              <Text3>
                사업자등록번호: 739-87-02408 &nbsp;&nbsp;&nbsp;&nbsp; 통신판매신고번호: 2022-서울성동-00372 
              </Text3>
              <Text3>
                
              </Text3>
              <Text3>
                주소 : 04766 서울특별시 성동구 왕십리로 125 (성수동1가, KD타워) 723호
              </Text3>
            </SecondLine>
          </TextBoxInSecond>
          <Text2>ⒸPhoty peta Inc. All rights reserved.</Text2>
        </ContetBoxInSecondBox>
        <ConstextBoxInSecondBox2>
          <Firstline>
            <BoldText2>고객센터</BoldText2>
          </Firstline>
          <Firstline>
            <BoldText2>전화: 070-8098-3914</BoldText2>
          </Firstline>
          <Firstline>
            <BoldText2>이메일: contact@photypeta.com</BoldText2>
          </Firstline>
          <Firstline>
            <Text2>
              운영시간: 평일 10시 ~ 18시(점심시간: 12시 ~ 13시), 주말 휴무
            </Text2>
          </Firstline>
        </ConstextBoxInSecondBox2>
      </SecondBox>
    </Container>
  )
}

export default Footer;

const Container = styled.div`
  background-color: #F1EDE1;
  width: 100%;
  height: 100%;
`
const ContentsContainter = styled.div`
  max-width: 1024px;
  height: 100%;
  margin: 0 auto;
  
  display: flex;
  flex-direction: row-reverse;
`
const FirstBox = styled.div`
  width: 100%;
  height: 59px;
  border-bottom:1px solid #E5E5E5;
  flex-direction: row-reverse;
`;
const HTextBox = styled.div`
  width: 285px;
  height: 26px;
  margin-top: 18px;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
`;
const BoldText = styled.a`
  margin-top:3px;
  color: rgba(101, 101, 101, 1);
  font-family: 'Pretendard';
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 14px;
  
  margin-right: 40px;
  white-space:nowrap;
  text-decoration-line: none;
`
const LinkUrl = styled.a`
  margin-top:3px;
  color: rgba(101, 101, 101, 1);
  font-family: 'Pretendard';
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 14px;
  
  margin-right: 15px;
  white-space:nowrap ;
  text-decoration-line: none;
  
  :hover {
    cursor: pointer;
    color:lightgray;
  }
`

const SecondBox = styled.div`
  max-width: 1024px;
  width: 100%;
  height:318px;
  display: flex;
  flex-direction: row;
  margin: 0 auto;
  justify-content: space-between;
`

const ContetBoxInSecondBox = styled.div`
  max-width: 450px;
  width: 90%;
  height: 265px;

  margin-top: 43px;
  padding-left: 10px;
  display: flex;
  flex-direction: column;
`

const ImgBox = styled.div`
  width: 255px;
  height: 32px;
`
const Image = styled.img`
  height: 100%;
`

const TextBoxInSecond = styled.div`
  max-width: 567px;
  height: 149px;
  width: 90%;
  margin-top: 48px;

  display: flex;
  flex-direction: column;
`
const Firstline = styled.div`
  display: flex;
  flex-direction: row;
  align-items: baseline;
  margin-top: 3px;
`

const SecondLine = styled.div`
`

const BoldText2 = styled.p`
  font-size: 16px;
  font-weight: 700;
  color:black;

  margin-top: 0px;
  margin-right: 15px;
  margin-bottom: 3px;
  white-space:nowrap ;
`
const Text3 = styled.p`
  font-size: 14px;
  font-weight: 400;
  margin-top: 0px;
  margin-bottom: 6px;
  color: black;
  white-space:nowrap;
`

const Text2 = styled.div`
  width: 100%;
  height: 27px;
  margin-top: -4px;
  color: #A4A4A4;
  font-size: 14px;
  font-weight: 400;
`
const ConstextBoxInSecondBox2 = styled.div`
  max-width: 567px;
  height: 149px;

  margin-top: 123px;
`;